import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
import { ScFieldsFragmentDoc, ScWithMinMaxFieldsFragmentDoc } from './share-class.graphql';
export type GqlSnrSccFieldsFragment = { id: string, companyId: string, name: string, serialNumber: string, filingYear: string, filingNumber: string, registrationDate: string, currency: Types.GqlCurrency, decisionDate?: string | null, amountTotal: string, amountChange: string, sharesChange?: string | null, sharesTotal?: string | null, sharePriceFactor?: string | null, sharesTotalSplitAdjusted?: string | null, transactionValue?: string | null, shareValue?: string | null, companyValue?: string | null, sharesTotalAfterChange?: string | null, foundersShareFraction?: string | null, sharesChangeSplitAdjusted?: string | null, companyValuePreMoney?: string | null, amountTotalBeforeChange: string, shareValueSplitAdjusted?: string | null, done: boolean, decisionDateWarning: boolean, sortOrderSnr?: number | null, sortOrder?: number | null, splitFactor: string, splitSharesChange: string, sortOrderOverride?: number | null, createdAt: string, updatedAt: string, shareClasses: Array<{ name: string, voteWeight: string, quantity?: string | null }> };

export const SnrSccFieldsFragmentDoc = gql`
    fragment SnrSccFields on SnrShareCapitalChange {
  id
  companyId
  name
  serialNumber
  filingYear
  filingNumber
  registrationDate
  currency
  decisionDate
  amountTotal
  amountChange
  sharesChange
  sharesTotal
  sharePriceFactor
  sharesTotalSplitAdjusted
  transactionValue
  shareValue
  companyValue
  sharesTotalAfterChange
  foundersShareFraction
  sharesChangeSplitAdjusted
  companyValuePreMoney
  amountTotalBeforeChange
  shareValueSplitAdjusted
  shareClasses {
    ...ScFields
  }
  done
  decisionDateWarning
  sortOrderSnr
  sortOrder
  splitFactor
  splitSharesChange
  sortOrderOverride
  createdAt
  updatedAt
}
    ${ScFieldsFragmentDoc}`;